import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import bannerPWA from "~/assets/banner_pwa.png";
import { DialogSafariInstall } from "./DialogSafariInstall";

export const AddToHomeScreenSafari: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    setShouldShowBanner(true);
  }, []);

  if (!shouldShowBanner) {
    // console.log("Safari banner hidden"); // debug
    return null;
  }

  const handleDialogClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: "env(safe-area-inset-bottom)",
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1300,
          backgroundColor: "rgba(26, 11, 43, 1)",
          cursor: "pointer",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "53px",
            backgroundColor: "rgba(26, 11, 43, 1)",
            color: "#FFFFFF",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            boxShadow: 3,
            textAlign: "center",
          }}
        >
          {/** biome-ignore lint/a11y/useKeyWithClickEvents: needs a click event for accessibility */}
          <img
            src={bannerPWA}
            style={{ height: "53px" }}
            alt="Add to Home Screen"
            onClick={() => {
              setOpen(true);
            }}
          />
        </Box>
      </Box>

      <DialogSafariInstall open={open} onClose={handleDialogClose} />
    </>
  );
};
